import React, { PureComponent } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import virtualize from "react-swipeable-views-utils/lib/virtualize";
import bindKeyboard from "react-swipeable-views-utils/lib/bindKeyboard";
import { setTitle } from "../actions/AppActions";
import { SetShownDay } from "../actions/TaskActions";
import DayTasks from "./DayTasks";
//import DateHelper from "../helpers/date-helper";
import moment from "moment";
// import "moment/locale/de";
// import "moment/locale/en-gb";
// import "moment/locale/nl";
import "moment/min/locales";

const EnhancedSwipeableViews = virtualize(bindKeyboard(SwipeableViews));

class SwipeableDays extends PureComponent{
  state = {
    shownDay: 10
  };

  componentDidMount() {
    this.setState({ shownDay: this.props.shownDay });
    //console.log("Did mount.");
    let loadLastVisited = localStorage.getItem("LastVisitedDate");
    if(loadLastVisited){
      let temp = parseInt(loadLastVisited);
      this.handleChangeIndex(temp);
    }
    moment.locale(this.props.settings.CurrentLang);
  }


  slideRenderer = params => {
    const { index, key } = params;
    return <DayTasks key={key} day={index} />;
  }

  handleChangeIndex = index => {
    //moment.locale(this.props.settings.CurrentLang);
    //console.log("day", index);
    const fx = () => {
        this.props.SetShownDay(index);
    };
    setTimeout(fx, 400);

    this.setState({ shownDay: index });

    // let date = new DateHelper().getDateByIndex(index);
    // date = date.format("MMMM DD, YYYY");

    localStorage.setItem("LastVisitedDate", index);
  };

  refreshDay = (index, type) => {
    let date = this.getDateString(index);

    localStorage.setItem("LastVisitedDate", date);
  }

  render(){
    return (
      <div style={{ backgroundColor: "#ffffff" }}>
        <div style={{ marginTop: "56px"}}>
          <EnhancedSwipeableViews
            enableMouseEvents
            slideCount={50}
            overscanSlideAfter={1}
            overscanSlideBefore={1}
            index={this.state.shownDay}
            //onSwitching={this.refreshDay}
            onChangeIndex={e => {
              this.handleChangeIndex(e);
              //console.log("chIndex");
              this.props.appointments.map(a => {
                return a;
              });
            }}
            slideRenderer={this.slideRenderer}
          />
        </div>
      </div>
    )
  }
}

SwipeableDays.propTypes = {
  setTitle: PropTypes.func.isRequired,
  SetShownDay: PropTypes.func.isRequired,
  appointments: PropTypes.array.isRequired,
  settings: PropTypes.object.isRequired,
  shownDay: PropTypes.number.isRequired
}

// const mapStateToProps = state => ({
//   appointments: state.tasks.appointments,
//   settings: state.settings,
//   //shownDay: state.tasks.shownDay,
//   application: state.app
// });

function mapStateToProps(state){
  //console.log("Swipeable state,", state);
  return {
  appointments: state.tasks.appointments,
  settings: state.settings,
  shownDay: state.tasks.shownDay,
  application: state.app
  }
}

export default connect(mapStateToProps, { setTitle, SetShownDay })(SwipeableDays);